<template>
    <div v-if="isGateVisible" class="minimum-profile-gate">
        <MinimumProfileForm
            @saved="onSaved"
        />
    </div>
</template>

<script>
import MinimumProfileForm from '@/components/MinimumProfileForm.vue'
import {isMinimumProfileComplete} from '@/shared/MinimumProfile'
import {useApiStore} from '@/store/api'

export default {
    name: 'MinimumProfileGate',

    components: {MinimumProfileForm},

    setup() {
        const apiStore = useApiStore()
        return {apiStore}
    },

    computed: {
        // The gate only prompts on non-profile content views. While the user
        // is already in their own profile area there's no need to nag them, so
        // it stays hidden on those routes regardless of completeness.
        isProfileRoute() {
            const profileRoutes = [
                'myprofileview', 'personalinfoview', 'myinterestsview',
                'mycredittypesview', 'profilephotoview', 'addaddressview',
                'editaddressview', 'roleview', 'presenterinfoview', 'transcript',
            ]
            return profileRoutes.includes(this.$route.name)
        },
        isGateVisible() {
            return !this.isHidden && !this.isProfileRoute
        },
        isHidden() {
            const attendee = this.apiStore.currentAttendee
            if (null == attendee) {
                return true
            }
            // If anything required is now missing, re-prompt even when a prior
            // confirmation timestamp exists — clearing a required field means
            // the attendee has to confirm again. Checked against the in-memory
            // attendee so the gate reacts immediately to edits.
            if (!isMinimumProfileComplete(attendee)) {
                return false
            }
            // Otherwise hide only once confirmed. is_minimum_profile_confirmed is
            // true only when a confirmation timestamp exists AND the rule is
            // satisfied, so a complete-but-unconfirmed profile still shows.
            return !!attendee.is_minimum_profile_confirmed
        },
    },

    methods: {
        onSaved() {
            // isHidden recomputes from apiStore.currentAttendee; nothing to do
        },
    },
}
</script>
